import React from 'react';
import styled from '@emotion/styled';

const QuantityContainer = styled.div`
  font-size: 14px;
`;

interface ItemQuantityProps {
  quantity: number;
}

const ItemQuantity: React.FC<ItemQuantityProps> = ({ quantity}) => {
  return (
    <QuantityContainer>
      {quantity}
    </QuantityContainer>
  );
};

export default ItemQuantity;